import { z } from "zod"
import { weeklyStringInputSchema } from "@/features/weekly/validation"

/**
 * Schema for validating monthly calculator form string input fields.
 * Uses the same schema as weekly (period field already omitted).
 */
export const monthlyStringInputSchema = weeklyStringInputSchema

/**
 * Schema for the complete monthly calculator form with distribution validation
 */
export const monthlyFormSchema = monthlyStringInputSchema.superRefine((values, ctx) => {
  const dayDistributionFields = [
    "distributionMonday",
    "distributionTuesday",
    "distributionWednesday",
    "distributionThursday",
    "distributionFriday",
    "distributionSaturday",
    "distributionSunday",
  ] as const

  const total = dayDistributionFields.reduce((sum, key) => {
    return sum + (Number(values[key] || 0) || 0)
  }, 0)

  // Allow small floating point differences (tolerance of 0.01%)
  if (Math.abs(total - 100) > 0.01) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: "form.errors.distribution.totalNot100",
      path: ["distributionSunday"],
    })
  }
})

export type MonthlyStringInputData = z.infer<typeof monthlyFormSchema>
